import React, { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { 
  FaHome, 
  FaChartBar, 
  FaWallet, 
  FaCog, 
  FaSignOutAlt,
  FaUserCircle,
  FaFolder,
  FaPlus,
  FaList,
  FaChevronDown,
  FaChevronUp,
  FaExchangeAlt,
  FaCreditCard,
  FaPiggyBank,
  FaMoneyBillWave,
  FaChartPie
} from 'react-icons/fa';
import './Sidebar.css';

const Sidebar = ({ isCollapsed, isMobile, isOpen, onClose }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const [openDropdowns, setOpenDropdowns] = useState({
    categories: false,
    transactions: false,
    paymentMethods: false,
    budget: false,
    savings: false,
    credits: false
  });
  const userData = JSON.parse(localStorage.getItem('userData') || '{}');

  const menuItems = [
    { path: '/dashboard', icon: <FaHome />, label: 'Dashboard' },
  ];

  const dropdownItems = {
    categories: {
      icon: <FaFolder />,
      label: 'Categories',
      items: [
        { path: '/create-category', icon: <FaPlus />, label: 'Create Category' },
        { path: '/transaction-categories', icon: <FaList />, label: 'View Categories' },
      ]
    },
    transactions: {
      icon: <FaExchangeAlt />,
      label: 'Transactions',
      items: [
        { path: '/create-transaction', icon: <FaPlus />, label: 'Create Transaction' },
        { path: '/transactions', icon: <FaList />, label: 'View Transactions' },
        { path: '/transaction-history', icon: <FaChartBar />, label: 'Transaction History' },
      ]
    },
    paymentMethods: {
      icon: <FaCreditCard />,
      label: 'Payment Methods',
      items: [
        { path: '/create-payment-method', icon: <FaPlus />, label: 'Add Payment Method' },
        { path: '/payment-methods', icon: <FaList />, label: 'View Payment Methods' },
      ]
    },
    budget: {
      icon: <FaChartPie />,
      label: 'Budget',
      items: [
        { path: '/create-budget', icon: <FaPlus />, label: 'Create Budget' },
        { path: '/budgets', icon: <FaList />, label: 'View Budgets' },
        { path: '/budget-analysis', icon: <FaChartBar />, label: 'Budget Analysis' },
      ]
    },
    savings: {
      icon: <FaPiggyBank />,
      label: 'Savings',
      items: [
        { path: '/create-savings-goal', icon: <FaPlus />, label: 'Create Savings Goal' },
        { path: '/savings-goals', icon: <FaList />, label: 'View Savings Goals' },
        { path: '/savings-analysis', icon: <FaChartBar />, label: 'Savings Analysis' },
      ]
    },
    credits: {
      icon: <FaMoneyBillWave />,
      label: 'Credits',
      items: [
        { path: '/create-credit', icon: <FaPlus />, label: 'Add Credit' },
        { path: '/credits', icon: <FaList />, label: 'View Credits' },
        { path: '/credit-analysis', icon: <FaChartBar />, label: 'Credit Analysis' },
      ]
    }
  };

  const handleLogout = () => {
    localStorage.removeItem('authToken');
    localStorage.removeItem('userData');
    navigate('/login');
  };

  const handleNavClick = () => {
    if (isMobile) {
      onClose();
    }
  };

  const toggleDropdown = (dropdown) => (e) => {
    e.preventDefault();
    setOpenDropdowns(prev => ({
      ...prev,
      [dropdown]: !prev[dropdown]
    }));
  };

  const isDropdownActive = (items) => {
    return items.some(item => location.pathname === item.path);
  };

  return (
    <div className={`sidebar ${isCollapsed ? 'collapsed' : ''} ${isMobile ? 'mobile' : ''} ${isOpen ? 'open' : ''}`}>

      <div className="user-profile">
        <div className="user-avatar">
          
            <img src="/carson5.jpg" alt="Profile" />
         
        </div>
        {(!isCollapsed || isMobile) && (
          <div className="user-info">
            <h3 style={{color: '#fff'}}>{userData.name || 'Carson'}</h3>
            <p style={{color: '#fffb'}}>{userData.email || 'muzarabanicarson@gmail.com'}</p>
          </div>
        )}
      </div>

      <nav className="sidebar-nav">
        {/* Main Menu Items */}
        {menuItems.map((item) => (
          <Link
            key={item.path}
            to={item.path}
            className={`nav-item ${location.pathname === item.path ? 'active' : ''}`}
            title={isCollapsed && !isMobile ? item.label : ''}
            onClick={handleNavClick}
          >
            <span className="nav-icon">{item.icon}</span>
            {(!isCollapsed || isMobile) && <span className="nav-label">{item.label}</span>}
          </Link>
        ))}

        {/* Dropdown Menus */}
        {Object.entries(dropdownItems).map(([key, dropdown]) => (
          <div 
            key={key}
            className={`nav-dropdown ${openDropdowns[key] ? 'open' : ''} ${isDropdownActive(dropdown.items) ? 'active' : ''}`}
          >
            <button 
              className="nav-dropdown-toggle"
              onClick={toggleDropdown(key)}
              title={isCollapsed && !isMobile ? dropdown.label : ''}
            >
              <span className="nav-icon">{dropdown.icon}</span>
              {(!isCollapsed || isMobile) && (
                <>
                  <span className="nav-label">{dropdown.label}</span>
                  <span className="dropdown-icon">
                    {openDropdowns[key] ? <FaChevronUp /> : <FaChevronDown />}
                  </span>
                </>
              )}
            </button>
            
            {(!isCollapsed || isMobile) && openDropdowns[key] && (
              <div className="nav-dropdown-menu">
                {dropdown.items.map((item) => (
                  <Link
                    key={item.path}
                    to={item.path}
                    className={`nav-dropdown-item ${location.pathname === item.path ? 'active' : ''}`}
                    onClick={handleNavClick}
                  >
                    <span className="nav-icon">{item.icon}</span>
                    <span className="nav-label">{item.label}</span>
                  </Link>
                ))}
              </div>
            )}
          </div>
        ))}

        {/* Settings Link */}
        <Link
          to="/settings"
          className={`nav-item ${location.pathname === '/settings' ? 'active' : ''}`}
          title={isCollapsed && !isMobile ? 'Settings' : ''}
          onClick={handleNavClick}
        >
          <span className="nav-icon"><FaCog /></span>
          {(!isCollapsed || isMobile) && <span className="nav-label">Settings</span>}
        </Link>
      </nav>

      <div className="sidebar-footer">
        <button 
          className="logout-btn"
          onClick={handleLogout}
          title={isCollapsed && !isMobile ? 'Logout' : ''}
        >
          <span className="nav-icon"><FaSignOutAlt /></span>
          {(!isCollapsed || isMobile) && <span className="nav-label">Logout</span>}
        </button>
      </div>
    </div>
  );
};

export default Sidebar;
